import { getAuth } from "firebase/auth";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import CreateExpense from "../../../../Controllers/Admin/Expense/CreateExpense";
import GetSingleExpense from "../../../../Controllers/Admin/Expense/GetSingleExpense";
import UpdateExpense from "../../../../Controllers/Admin/Expense/UpdateExpense";
import GetAllTeacher from "../../../../Controllers/Users/GetAllTeacher";

const AddExpensesViewModal = () => {
  const navigate = useNavigate();

  const [NewExpense, setNewExpense] = useState({
    Date: "",
    ExpenseItem: "",
    ExpenseAmount: 0,
    ExpenseType: "",
    ExpensePurchaseSource: "",
  });

  const [ExpenseItemError, setExpenseItemError] = useState(false);
  const [ExpenseTypeError, setExpenseTypeError] = useState(false);
  const [ExpenseDateError, setExpenseDateError] = useState(false);
  const [ExpenseAmountError, setExpenseAmountError] = useState(false);
  const [ExpensePurchaseSourceError, setExpensePurchaseSourceError] =
    useState(false);

  const [IsCheckError, setIsCheckError] = useState(false);
  const [IsUpdate, setIsUpdate] = useState(false);
  const [loader, setLoader] = useState(false);
  const [DocId, setDocId] = useState("");
  const [AllTeachers, setAllTeachers] = useState([]);
  const [UserType, setUserType] = useState("teacher");
  const [UserId, setUserId] = useState();
  const [UserIdError, setUserIdError] = useState();
  const [ExpenseUserTypeError, setExpenseUserTypeError] = useState();

  useEffect(() => {
    if (IsCheckError) UIErrorHandling();
  }, [
    IsCheckError,
    NewExpense.Date,
    NewExpense.ExpenseItem,
    NewExpense.ExpenseAmount,
    NewExpense.ExpensePurchaseSource,
    NewExpense.ExpenseType,
  ]);

  useEffect(() => {
    if (window.location.pathname.includes("update")) {
      setIsUpdate(true);
      const urlParams = new URLSearchParams(window.location.search);
      let UpdateExpenseId = urlParams.get("id");
      setDocId(UpdateExpenseId);

      const fetchData = async () => {
        let resp = await GetSingleExpense(UpdateExpenseId);

        if (resp) {
          setUserType(resp?.UserType);
          setUserId(resp?.UserId);

          setNewExpense({
            ExpenseItem: resp.ExpenseItem,
            Date: resp.Date,
            ExpenseAmount: resp.ExpenseAmount,
            ExpensePurchaseSource: resp.ExpensePurchaseSource,
            ExpenseType: resp.ExpenseType,
          });
        }
      };
      fetchData();
    }
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      let resp = await GetAllTeacher();
      setAllTeachers([...resp]);
    };
    fetchData();
  }, []);

  const UIErrorHandling = () => {
    let flag = 0;

    if (
      NewExpense.ExpenseType === "" ||
      NewExpense.ExpenseType === null ||
      NewExpense.ExpenseType === undefined
    ) {
      setExpenseTypeError(true);
      flag++;
    } else {
      setExpenseTypeError(false);
    }
    if (NewExpense.ExpenseType === "salary") {
      if (UserType === "" || UserType === null || UserType === undefined) {
        setExpenseUserTypeError(true);
        flag++;
      } else {
        setExpenseUserTypeError(false);
      }
      if (UserId === "" || UserId === null || UserId === undefined) {
        setUserIdError(true);
        flag++;
      } else {
        setUserIdError(false);
      }
    }
    if (
      NewExpense.Date === "" ||
      NewExpense.Date === null ||
      NewExpense.Date === undefined
    ) {
      setExpenseDateError(true);
      flag++;
    } else {
      setExpenseDateError(false);
    }
    if (
      NewExpense.ExpenseItem === "" ||
      NewExpense.ExpenseItem === null ||
      NewExpense.ExpenseItem === undefined
    ) {
      setExpenseItemError(true);
      flag++;
    } else {
      setExpenseItemError(false);
    }
    if (
      NewExpense.ExpenseAmount === 0 ||
      NewExpense.ExpenseAmount === null ||
      NewExpense.ExpenseAmount === undefined
    ) {
      setExpenseAmountError(true);
      flag++;
    } else {
      setExpenseAmountError(false);
    }
    if (
      NewExpense.ExpensePurchaseSource === "" ||
      NewExpense.ExpensePurchaseSource === null ||
      NewExpense.ExpensePurchaseSource === undefined
    ) {
      setExpensePurchaseSourceError(true);
      flag++;
    } else {
      setExpensePurchaseSourceError(false);
    }
    return flag;
  };

  const AddNewExpense = async (e) => {
    setIsCheckError(true);
    let flag = 0;
    flag = UIErrorHandling();

    let TempObject = { ...NewExpense };

    if (flag === 0) {
      if (NewExpense.ExpenseType === "salary") {
        TempObject = {
          ...TempObject,
          UserType,
          UserId,
        };
      }
      setLoader(true);
      if (IsUpdate) {
        let resp = await UpdateExpense(TempObject, DocId);
        setLoader(false);
        navigate("/user/admin/expenses");
        return;
      }

      let resp = await CreateExpense(TempObject, getAuth().currentUser.uid);
      setLoader(false);
      navigate("/user/admin/expenses");
    }
  };

  return {
    NewExpense,
    setNewExpense,
    AddNewExpense,
    ExpenseItemError,
    ExpenseDateError,
    ExpenseAmountError,
    ExpensePurchaseSourceError,
    IsUpdate,
    loader,
    ExpenseTypeError,
    AllTeachers,
    UserType,
    setUserType,
    UserId,
    setUserId,
    ExpenseUserTypeError,
    UserIdError,
  };
};

export default AddExpensesViewModal;
